const formFieldConstants = {
  TEXT: "text",
  RADIO: "radio",
  SUBMIT: "submit",
  NUMBER: "number",
  HIDDEN: "hidden",
  SELECT: "select",
  PASSWORD: "password",
  CHECKBOX: "checkbox",
  TEXTAREA: "textarea",
  TEL: "tel",
  SEARCH: "search",
  EMAIL: "email",
}

export default formFieldConstants
